import { ErrorHandler, Injectable } from '@angular/core';
import { faro } from '@grafana/faro-web-sdk';

@Injectable()
export class MetricsErrorHandler implements ErrorHandler {
  private readonly defaultHandler = new ErrorHandler();

  handleError(error: unknown): void {
    faro.api.pushError(error instanceof Error ? error : new Error(String(error)));
    this.defaultHandler.handleError(error);
  }
}
